module.exports = __webpack_public_path__ + "img/znh.37f141fd.jpg";